import fetcher from '@/utils/fetcher';

// eslint-disable-next-line @typescript-eslint/promise-function-async
const loginUserFetcher = (): Promise<void> =>
  fetcher({
    endpoint: `/users/login`,
  });

export default loginUserFetcher;
